import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import parse from "html-react-parser";

//
import "./accordionItem.component.scss";

export interface AccordionItemDataProps {
  question: string;
  answer: string[];
}

interface Props extends AccordionItemDataProps {
  open: boolean;
  onClick: () => void;
  index: number;
}

const AccordionItem: React.FC<Props> = (props) => {
  const [height, setHeight] = useState<number>(0);
  const innerRef = useRef<HTMLDivElement>(null);

  const str1 = props.index.toString();
  const itemIndex = str1.padStart(3, "0");

  useEffect(() => {
    const inner = innerRef.current;
    if (!!inner) {
      setHeight(props.open ? inner.clientHeight : 0);
    }
  }, [props.open])

  return (
    <div
      className={classNames("accordion-item", { "is-open": props.open })}
      onClick={props.onClick}
    >
      <div className="accordion-item-question">
        <span className="accordion-item-question__index">{itemIndex}</span>
        {props.question}
        <span className="accordion-item-question__arrow"></span>
      </div>
      <div className="accordion-item-answer" style={{ height: `${height}px` }}>
        <div className="accordion-item-answer__inner" ref={innerRef}>
          {props.answer.map((item, key) => (
            <p key={key}>
              {parse(item)}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;
